export default "<lib-resource-instance-monitoring-average [selectedMonitoringItemsId]=\"selectedMonitoringItemsId\"></lib-resource-instance-monitoring-average>"